import { render, staticRenderFns } from "./AccettazioneSsnAnagraficaComponent.vue?vue&type=template&id=6b13d1db&scoped=true"
import script from "./AccettazioneSsnAnagraficaComponent.vue?vue&type=script&lang=js"
export * from "./AccettazioneSsnAnagraficaComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b13d1db",
  null
  
)

export default component.exports